import * as React from 'react'

export default (props) =>
  <svg xmlns="http://www.w3.org/2000/svg" width="7.311" height="13.121" viewBox="0 0 7.311 13.121"  {...props}>
    <g id="Icon_arrow" data-name="Icon / arrow" transform="translate(6.25 1.061) rotate(90)">
      <path id="Path_32682" data-name="Path 32682" d="M12,4.5,6.5,10,1,4.5" transform="translate(-1 -4.5)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </g>
  </svg>
